import { render, staticRenderFns } from "./Feet.vue?vue&type=template&id=0905772e&"
import script from "./Feet.vue?vue&type=script&lang=js&"
export * from "./Feet.vue?vue&type=script&lang=js&"
import style0 from "./Feet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports